import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PersonIcon from '@mui/icons-material/Person';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CelebrationIcon from '@mui/icons-material/Celebration';
import { Fade } from 'react-awesome-reveal';

const FEATURES = [
  {
    icon: <RestaurantIcon sx={{ fontSize: 40 }} />,
    title: 'Sushi premium en directo',
    desc: 'Elaborado al momento con ingredientes frescos de la máxima calidad.',
  },
  {
    icon: <PersonIcon sx={{ fontSize: 40 }} />,
    title: 'Sushiman profesional',
    desc: 'Nuestros chefs trabajan en vivo, explicando técnicas y creando experiencias memorables.',
  },
  {
    icon: <EmojiEventsIcon sx={{ fontSize: 40 }} />,
    title: 'Presentación impecable',
    desc: 'Montaje completo con vajilla, decoración y puesta en escena a la altura del evento.',
  },
  {
    icon: <CelebrationIcon sx={{ fontSize: 40 }} />,
    title: 'Todo tipo de eventos',
    desc: 'Bodas, eventos corporativos, celebraciones privadas, festivales y mucho más.',
  },
];

const Intro: React.FC = () => {
  return (
    <Box id="intro" sx={{ py: 10, background: 'var(--color-bg-section)' }}>
      <Container maxWidth="lg">
        <Fade triggerOnce direction="up">
          <Typography
            variant="h2"
            align="center"
            sx={{ fontFamily: 'var(--font-heading)', fontSize: { xs: '1.8rem', md: '2.5rem' }, mb: 2, color: 'var(--color-text-primary)' }}
          >
            Una experiencia gastronómica{' '}
            <Box component="span" sx={{ color: 'var(--color-accent)' }}>
              sin igual
            </Box>
          </Typography>
          <Typography align="center" sx={{ color: 'var(--color-text-secondary)', maxWidth: 600, mx: 'auto', mb: 8 }}>
            Llevamos la gastronomía japonesa contemporánea a donde la necesitas, con todo el diseño y la puesta en escena que tu evento merece.
          </Typography>
        </Fade>

        <Grid container spacing={4}>
          {FEATURES.map((f, i) => (
            <Grid key={i} size={{ xs: 12, sm: 6, md: 3 }}>
              <Fade triggerOnce direction="up" delay={i * 100}>
                <Box
                  sx={{
                    textAlign: 'center',
                    p: 3,
                    borderRadius: 2,
                    border: '1px solid var(--color-border)',
                    bgcolor: 'var(--color-bg-card)',
                    height: '100%',
                    transition: 'border-color 0.3s',
                    '&:hover': { borderColor: 'var(--color-accent)' },
                  }}
                >
                  <Box sx={{ color: 'var(--color-accent)', mb: 2 }}>{f.icon}</Box>
                  <Typography variant="h6" sx={{ color: 'var(--color-text-primary)', mb: 1.5, fontFamily: 'var(--font-heading)' }}>
                    {f.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'var(--color-text-secondary)', lineHeight: 1.7 }}>
                    {f.desc}
                  </Typography>
                </Box>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Intro;
